import { useLocation, useNavigate, Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { CustomerPasswordChangedEnum } from "@hooks/dtos/user-dto";
import { Header } from "@components/layout/header/index";
import Footer from "@components/layout/footer";

const ProtectedRoute = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  const { customer, actions } = ZuAuthStore();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifySession = async () => {
      await actions.checkIfHaveSession();
      setLoading(false);
    };

    verifySession();
  }, [actions]);

  useEffect(() => {
    if (
      customer &&
      customer.customer.pswdChanged === CustomerPasswordChangedEnum.FALSE &&
      location.pathname !== "/password/change"
    ) {
      navigate("/password/change");
      pushToastify({
        message: "É obrigatório a alteração da senha no primeiro login.",
        type: "warning",
        theme: "dark",
      });
    }
  }, [customer, location.pathname, navigate, pushToastify]);

  if (loading) return null;

  return customer ? (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Header />
      <main className="flex-grow-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;
